module.exports = __webpack_public_path__ + "img/door-check-out-icon.e06ab6ce.svg";